import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const url = "https://platform-api.settlemyloan.in";

export const getToken = createAsyncThunk("token/getToken", async () => {
  try {
    const res = await axios.get(`${url}/token`);
    return res.data.token[0].token;
  } catch (error) {
    throw error;
  }
});

export const generateToken = createAsyncThunk(
  "token/generateToken",
  async () => {
    try {
      const res = await axios.get(`${url}/token`);
      console.log(res.data);
    } catch (error) {
      throw error;
    }
  },
);

const tokenSlice = createSlice({
  name: "token",
  initialState: {
    token: null,
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getToken.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getToken.rejected, (state) => {
      state.loading = false;
      state.error = "Failed to fetch token";
    });
    builder.addCase(getToken.fulfilled, (state, action) => {
      state.loading = false;
      state.token = action.payload;
    });
    builder.addCase(generateToken.fulfilled, (state, action) => {
      console.log(action.payload);
    });
  },
});

export default tokenSlice.reducer;
